import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { productClassListApiSchema } from '../../../models';

const shipmentApi = fetcher.extend(() => ({ prefixUrl: `${API.SHIPMENT}` }));

export const fetchShipmentProductClassOptions = async ({ signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await shipmentApi.get('GetProductClass', { signal }).json(productClassListApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on Product Class response',
        (error as ValiError<typeof productClassListApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
